import React from 'react'
import { TCDataProvider, TeamsProvider, DisplayProvider, UploadedPlayersProvider, BADataProvider } from './'

export const ContextWrapper = ({ children }) => {
  return (
    <TCDataProvider>
      <BADataProvider>
        <TeamsProvider>
          <DisplayProvider>
            <UploadedPlayersProvider>
              {children}
            </UploadedPlayersProvider>
          </DisplayProvider>
        </TeamsProvider>
      </BADataProvider>
    </TCDataProvider>
  )
}